import React from 'react'

const CenterSupportPage = () => {
  return (
    <main className="container">
      <h1>Center Support</h1>
      <p>Chat with Obule support about payouts, events, or tickets.</p>
    </main>
  )
}

export default CenterSupportPage

